import { useSelector } from "react-redux";
import { RootState } from "./store";

export function useTypedSelector<T>(selector: (state: RootState) => T) {
  return useSelector(selector);
}
